<template>
	<div class="content-wrapper" v-if="isLoaded">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-view ref="searchView" :scrId="scrId"></search-view>
				</sf-card>
			</div>
			<div class="sf-col sf-col-15">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-view ref="tableView" @Refresh="refresh" :scrId="scrId" @OpenPopup="openPopup"></table-view>
				</sf-card>
			</div>
			<div class="sf-col sf-col-5">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<form-view ref="formView" @Refresh="refresh" :scrId="scrId"></form-view>
				</sf-card>
			</div>
		</div>
		<!-- 불량보고서 등록/수정 팝업 -->
		<popup-detail ref="popupRef" @Refresh="refresh" :scrId="scrId"></popup-detail>
	</div>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import { serviceComputed, serviceMethods } from '../store/helpers';
import SearchView from './Search/Search';
import TableView from './Table/Table';
import FormView from './Table/Form';
import PopupDetail from '@qms/pqy/pcku/PrtRpt/Content/Popup/Popup'; //불량보고서 등록/수정 팝업
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			isLoaded: false
		};
	},
	async created() {
		this.$sf_toggleLoading(true);
		this.$notify.closeAll(); // 에러 경고창 사라지는 명령어 (공통)
		try {
			await this.getCommCodes_({ key: 'badClCdList', codeType: 'BAD_CL' });
			await this.getCommCodes_({ key: 'badScnCdList', codeType: 'BAD_SCN' });
			await this.getCommCodes_({ key: 'powCdList', codeType: 'POW_OCCU' });
			this.setState_({ key: 'isPqyUser', value: await this.inclManyUsrGrp_(['PQYAP', 'PQYRV', 'PQYRG', 'OS']) });
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error?.message || error });
		} finally {
			this.isLoaded = true;
			this.$sf_toggleLoading(false);
		}
	},
	components: { SearchView, TableView, FormView, PopupDetail },
	computed: {
		...rootComputed,
		...qmsComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...qmsMethods,
		...serviceMethods,
		refresh() {
			this.$refs.searchView.searchList();
		},
		openPopup(params) {
			this.$refs.popupRef.open(params, 'OS');
		}
	}
};
</script>
